import {
    ApiResponse,
    get,
    post,
} from '../../utils/services';
import { CancelPayload, SubmittedPayload } from './genericBladeTypes';

export const fetchGenericBladeApi = (
    url: string,
): Promise<ApiResponse<unknown>> => get(url);

export const submitGenericBladeApi = (
    url: string,
    payload: SubmittedPayload,
): Promise<ApiResponse<unknown>> => post({ url, payload });

export const cancelGenericBladeApi = (
    url: string,
    payload?: CancelPayload,
): Promise<ApiResponse<unknown>> => post({ url, payload });
